var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 4.15625H2.96875",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71875 7.71875V12.4688",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 7.71875V12.4688",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 4.15625V15.4375C14.8438 15.595 14.7812 15.746 14.6698 15.8573C14.5585 15.9687 14.4075 16.0312 14.25 16.0312H4.75C4.59253 16.0312 4.44151 15.9687 4.33016 15.8573C4.21881 15.746 4.15625 15.595 4.15625 15.4375V4.15625",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 4.15625V2.96875C12.4688 2.65381 12.3436 2.35176 12.1209 2.12906C11.8982 1.90636 11.5962 1.78125 11.2812 1.78125H7.71875C7.40381 1.78125 7.10176 1.90636 6.87906 2.12906C6.65636 2.35176 6.53125 2.65381 6.53125 2.96875V4.15625",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c4e893a6dd46ca799ec0fb4c8f6a3aa2.svg";
export { ForwardRef as ReactComponent };